var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTravelImage2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7508",
    "data-name": "Path 7508",
    d: "M460.291,178.7h-8.357a6.325,6.325,0,0,1-.6,5.865,6.189,6.189,0,0,1-5.15,2.773H409.509a6.188,6.188,0,0,1-5.15-2.772,6.325,6.325,0,0,1-.6-5.865h-7.806A13.13,13.13,0,0,0,382.9,191.9V359.152a13.13,13.13,0,0,0,13.062,13.2h64.334a13.13,13.13,0,0,0,13.062-13.2h0V191.9A13.13,13.13,0,0,0,460.291,178.7Z",
    transform: "translate(-382.896 -178.7)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Illustration",
    transform: "translate(-62.363 -219.041)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "wrapper",
    width: 256,
    height: 256,
    transform: "translate(62.363 219.041)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Illustration-2",
    "data-name": "Illustration",
    transform: "translate(66.269 231.811)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2067",
    "data-name": "Path 2067",
    d: "M109.487,218.974C49.3,218.974,0,170.122,0,109.775S49.3,0,109.487,0,218.974,49.427,218.974,109.775,169.676,218.974,109.487,218.974Z",
    transform: "translate(0 0)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2067-2",
    "data-name": "Path 2067",
    d: "M105.981,211.962C47.719,211.962,0,164.674,0,106.259S47.719,0,105.981,0,211.962,47.844,211.962,106.259,164.243,211.962,105.981,211.962Z",
    transform: "translate(7.012 3.506)",
    fill: "#bce8fe"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_468",
    "data-name": "Ellipse 468",
    cx: 46.104,
    cy: 5.87,
    rx: 46.104,
    ry: 5.87,
    transform: "translate(153.485 218.659)",
    fill: "#6639b7",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1489",
    "data-name": "Ellipse 1489",
    cx: 51.475,
    cy: 5.87,
    rx: 51.475,
    ry: 5.87,
    transform: "translate(26.121 218.659)",
    fill: "#6639b7",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9998",
    "data-name": "Group 9998",
    transform: "translate(26.121 7.104)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10000",
    "data-name": "Group 10000",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7475",
    "data-name": "Path 7475",
    d: "M466.273,214.093V183.561a17.582,17.582,0,0,0-17.491-17.671H384.758a17.582,17.582,0,0,0-17.491,17.671v20.277h-1.125v7.145h1.125V218.6h-1.125v10.955h1.125v4.763h-1.125v10.955h1.125V351.062a17.582,17.582,0,0,0,17.491,17.671h64.025a17.582,17.582,0,0,0,17.491-17.671V235.826h1.1V214.093Z",
    transform: "translate(-366.142 -165.89)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7476",
    "data-name": "Path 7476",
    d: "M460.291,178.7h-8.357a6.325,6.325,0,0,1-.6,5.865,6.189,6.189,0,0,1-5.15,2.773H409.509a6.188,6.188,0,0,1-5.15-2.772,6.325,6.325,0,0,1-.6-5.865h-7.806A13.13,13.13,0,0,0,382.9,191.9V359.152a13.13,13.13,0,0,0,13.062,13.2h64.334a13.13,13.13,0,0,0,13.062-13.2h0V191.9A13.13,13.13,0,0,0,460.291,178.7Z",
    transform: "translate(-376.945 -174.103)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9999",
    "data-name": "Group 9999",
    transform: "translate(5.95 4.597)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_63",
    "data-name": "Mask Group 63",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5265",
    "data-name": "Rectangle 5265",
    width: 88.242,
    height: 23.599,
    transform: "translate(-0.706 172.316)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7513",
    "data-name": "Path 7513",
    d: "M3.552,0H9.235a3.571,3.571,0,0,1,3.552,3.589V8.254a3.571,3.571,0,0,1-3.552,3.589H3.552A3.571,3.571,0,0,1,0,8.254V3.589A3.571,3.571,0,0,1,3.552,0Z",
    transform: "translate(5.068 176.993)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7512",
    "data-name": "Path 7512",
    d: "M3.552,0H9.235a3.571,3.571,0,0,1,3.552,3.589V8.254a3.571,3.571,0,0,1-3.552,3.589H3.552A3.571,3.571,0,0,1,0,8.254V3.589A3.571,3.571,0,0,1,3.552,0Z",
    transform: "translate(21.762 176.993)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7511",
    "data-name": "Path 7511",
    d: "M3.552,0H9.235a3.571,3.571,0,0,1,3.552,3.589V8.254a3.571,3.571,0,0,1-3.552,3.589H3.552A3.571,3.571,0,0,1,0,8.254V3.589A3.571,3.571,0,0,1,3.552,0Z",
    transform: "translate(38.457 176.993)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7510",
    "data-name": "Path 7510",
    d: "M3.552,0H9.235a3.571,3.571,0,0,1,3.552,3.589V8.254a3.571,3.571,0,0,1-3.552,3.589H3.552A3.571,3.571,0,0,1,0,8.254V3.589A3.571,3.571,0,0,1,3.552,0Z",
    transform: "translate(55.152 176.993)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7509",
    "data-name": "Path 7509",
    d: "M3.552,0H9.235a3.571,3.571,0,0,1,3.552,3.589V8.254a3.571,3.571,0,0,1-3.552,3.589H3.552A3.571,3.571,0,0,1,0,8.254V3.589A3.571,3.571,0,0,1,3.552,0Z",
    transform: "translate(71.847 176.993)",
    fill: "#6639b7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5271",
    "data-name": "Rectangle 5271",
    width: 88.242,
    height: 13.111,
    transform: "translate(-0.706 1.877)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7521",
    "data-name": "Path 7521",
    d: "M3.552,0H77.791a3.571,3.571,0,0,1,3.552,3.589v6.46a3.571,3.571,0,0,1-3.552,3.589H3.552A3.571,3.571,0,0,1,0,10.049V3.589A3.571,3.571,0,0,1,3.552,0Z",
    transform: "translate(5.068 22.677)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7520",
    "data-name": "Path 7520",
    d: "M3.552,0H77.791a3.571,3.571,0,0,1,3.552,3.589v6.46a3.571,3.571,0,0,1-3.552,3.589H3.552A3.571,3.571,0,0,1,0,10.049V3.589A3.571,3.571,0,0,1,3.552,0Z",
    transform: "translate(5.068 41.698)",
    fill: "#6639b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7519",
    "data-name": "Path 7519",
    d: "M3.552,0H77.791a3.571,3.571,0,0,1,3.552,3.589v6.46a3.571,3.571,0,0,1-3.552,3.589H3.552A3.571,3.571,0,0,1,0,10.049V3.589A3.571,3.571,0,0,1,3.552,0Z",
    transform: "translate(5.068 60.359)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7518",
    "data-name": "Path 7518",
    d: "M3.552,0H77.791a3.571,3.571,0,0,1,3.552,3.589v6.46a3.571,3.571,0,0,1-3.552,3.589H3.552A3.571,3.571,0,0,1,0,10.049V3.589A3.571,3.571,0,0,1,3.552,0Z",
    transform: "translate(5.068 79.379)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7517",
    "data-name": "Path 7517",
    d: "M3.552,0H77.791a3.571,3.571,0,0,1,3.552,3.589v6.46a3.571,3.571,0,0,1-3.552,3.589H3.552A3.571,3.571,0,0,1,0,10.049V3.589A3.571,3.571,0,0,1,3.552,0Z",
    transform: "translate(5.068 98.041)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7516",
    "data-name": "Path 7516",
    d: "M3.552,0H77.791a3.571,3.571,0,0,1,3.552,3.589v6.46a3.571,3.571,0,0,1-3.552,3.589H3.552A3.571,3.571,0,0,1,0,10.049V3.589A3.571,3.571,0,0,1,3.552,0Z",
    transform: "translate(5.068 117.061)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7515",
    "data-name": "Path 7515",
    d: "M3.552,0H77.791a3.571,3.571,0,0,1,3.552,3.589v6.46a3.571,3.571,0,0,1-3.552,3.589H3.552A3.571,3.571,0,0,1,0,10.049V3.589A3.571,3.571,0,0,1,3.552,0Z",
    transform: "translate(5.068 135.723)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7514",
    "data-name": "Path 7514",
    d: "M3.552,0H77.791a3.571,3.571,0,0,1,3.552,3.589v6.46a3.571,3.571,0,0,1-3.552,3.589H3.552A3.571,3.571,0,0,1,0,10.049V3.589A3.571,3.571,0,0,1,3.552,0Z",
    transform: "translate(5.068 154.743)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "menu_1_",
    "data-name": "menu (1)",
    transform: "translate(73.991 179.695)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_210",
    "data-name": "Line 210",
    d: "M6.614-.719H-1.114A.388.388,0,0,1-1.5-1.11a.388.388,0,0,1,.386-.39H6.614A.388.388,0,0,1,7-1.11.388.388,0,0,1,6.614-.719Z",
    transform: "translate(1.5 4.33)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_211",
    "data-name": "Line 211",
    d: "M6.614-.719H-1.114A.388.388,0,0,1-1.5-1.11a.388.388,0,0,1,.386-.39H6.614A.388.388,0,0,1,7-1.11.388.388,0,0,1,6.614-.719Z",
    transform: "translate(1.5 1.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_212",
    "data-name": "Line 212",
    d: "M6.614-.719H-1.114A.388.388,0,0,1-1.5-1.11a.388.388,0,0,1,.386-.39H6.614A.388.388,0,0,1,7-1.11.388.388,0,0,1,6.614-.719Z",
    transform: "translate(1.5 7.16)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_7502",
    "data-name": "Path 7502",
    d: "M498.276,184.854h-9.591a.718.718,0,0,1,0-1.436h9.591a.718.718,0,0,1,0,1.436Z",
    transform: "translate(-444.699 -177.128)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1488",
    "data-name": "Ellipse 1488",
    cx: 0.71,
    cy: 0.718,
    rx: 0.71,
    ry: 0.718,
    transform: "translate(57.662 6.29)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10001",
    "data-name": "Group 10001",
    transform: "translate(82.699 13.011)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7485",
    "data-name": "Path 7485",
    d: "M718.591,284.468c-.847-6.281-1.911-13.024-6.3-17.558a14.642,14.642,0,0,0-21.3.223c-3.192,3.44-4.6,8.27-4.731,12.983s.91,9.374,2.063,13.943a42.165,42.165,0,0,0,17.754-3.53,28.428,28.428,0,0,1,4.257-1.688c1.479-.38,2.533.577,3.909,1.244l.755-1.461c.618,1.163,2.533.818,3.227-.3A5.814,5.814,0,0,0,718.591,284.468Z",
    transform: "translate(-644.182 -262.425)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7486",
    "data-name": "Path 7486",
    d: "M589.3,513.022l-4.48,2.993-13.561-16.034,6.612-4.418Z",
    transform: "translate(-460.327 -321.76)",
    fill: "#9e616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7487",
    "data-name": "Path 7487",
    d: "M876.2,701.777l-14.039,9.781-.117-.187a7.13,7.13,0,0,1,1.85-9.564h0l8.574-5.974Z",
    transform: "translate(-745.313 -507.02)",
    fill: "#fff",
    stroke: "#e6e6e6",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7488",
    "data-name": "Path 7488",
    d: "M470.264,526.759h-5.371l-2.555-20.931h7.928Z",
    transform: "translate(-399.13 -327.48)",
    fill: "#9e616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7489",
    "data-name": "Path 7489",
    d: "M739.213,722.034H719.187v-.221c0-3.761,3.49-6.81,7.794-6.81h12.232Z",
    transform: "translate(-666.708 -517.496)",
    fill: "#fff",
    stroke: "#ebebeb",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7490",
    "data-name": "Path 7490",
    d: "M632.279,370,612,355.369a3.944,3.944,0,1,0-4.735,3.429c2.535,2.15,21.052,20.753,23.7,19.772,2.691-1,14.456-2.8,14.456-2.8l.327-11.285Z",
    transform: "translate(-599.361 -314.564)",
    fill: "#9e616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7504",
    "data-name": "Path 7504",
    d: "M691.326,392.612l3.433-.494-6.354-9.041-1.892.85Z",
    transform: "translate(-646.959 -331.159)",
    opacity: 0.102
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7491",
    "data-name": "Path 7491",
    d: "M704.733,450.622l.191,25.751s4.389,38.154,6.008,44.6,6.874,46.178,6.874,46.178,7.633,2.518,9.943,0-4.825-50.642-4.825-50.642L725,484.19l11.989,32.39S774.345,562,777.811,563.153s6.4-4.9,6.4-4.9L748.653,503.1l-8.094-32.228s1.007-16.669-8.062-23.088Z",
    transform: "translate(-655.881 -368.553)",
    fill: "#6639b7"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1487",
    "data-name": "Ellipse 1487",
    cx: 11.707,
    cy: 11.827,
    rx: 11.707,
    ry: 11.827,
    transform: "translate(44.594 4.603)",
    fill: "#9e616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7506",
    "data-name": "Path 7506",
    d: "M.106,1.1,6.885,0s1.907,8.756.941,11.084-5.459,2.7-6.864-.23S.106,1.1.106,1.1Z",
    transform: "translate(58.47 24.52) rotate(-7)",
    fill: "#9e616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7507",
    "data-name": "Path 7507",
    d: "M705.829,461.234v3.72c3.215.191,19.024-1.462,19.024-1.462l16.795-.824A16.264,16.264,0,0,0,740.133,455C738.231,450.649,705.829,461.234,705.829,461.234Z",
    transform: "translate(-656.978 -363.139)",
    opacity: 0.096
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7492",
    "data-name": "Path 7492",
    d: "M593.233,362.657",
    transform: "translate(-593.233 -321.106)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7493",
    "data-name": "Path 7493",
    d: "M724.906,345.97c-1.38-2.774-.534-3.056-3.475-3.955-1.019-.312-6.452,11.024-6.452,11.024s-5.193-9.45-6.074-8.95c-3.011,1.705-1.1,1.01-2.878,4l-5.793,9.751a30.408,30.408,0,0,0-3.387,7,10.3,10.3,0,0,0,.47,7.607c1.095,2.054,1.1,6.545,2.2,8.6,1.144,2.132-.55,11.1-.55,11.1l.55,17.846c2.5.148,8.543-1.32,14.565-1.886,10.755-1.011,22.756-1.532,22.756-1.532s-1.253-12.639-3.154-16.991-4.47-4.011-3.946-6.577A57.925,57.925,0,0,0,724.906,345.97Z",
    transform: "translate(-651.168 -309.597)",
    fill: "#6639b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7494",
    "data-name": "Path 7494",
    d: "M695.423,374.622a80.676,80.676,0,0,0,8.971-9.954c2.611-3.637-.567-6.439,0-10.9.242-1.422,5.355-4.242,4.927-5.618a4.343,4.343,0,0,0-2.952-2.855c-2.222-.493-4.243,1.3-5.828,2.947l-14.027,14.578,8.935,11.882Z",
    transform: "translate(-645.645 -311.384)",
    fill: "#6639b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7495",
    "data-name": "Path 7495",
    d: "M750.012,398.325c-.986-2.718-2.77-14.6-2.77-14.6l-11.17-.331L741.532,397l-14.9,21.076.078.129a3.928,3.928,0,0,0-4.023,1.916,4.015,4.015,0,0,0,.305,4.482,3.918,3.918,0,0,0,4.245,1.341,3.973,3.973,0,0,0,2.779-3.508.27.27,0,0,0,.342-.059C732.013,420.272,751,401.043,750.012,398.325Z",
    transform: "translate(-665.663 -332.662)",
    fill: "#9e616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7496",
    "data-name": "Path 7496",
    d: "M762.4,367.672a81.607,81.607,0,0,0-3.787-12.906,27.108,27.108,0,0,0-7.684-10.846,8.956,8.956,0,0,0-3.752-1.961,4.294,4.294,0,0,0-3.946,1.074c-1.568,1.666-1.1,4.339-.521,6.563l5.086,19.67,14.688-1.573Z",
    transform: "translate(-676.913 -309.515)",
    fill: "#6639b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7503",
    "data-name": "Path 7503",
    d: "M770.994,398.893l-.252-1.377-8.954.935a4.18,4.18,0,0,1,.5,1.487C767.182,399.414,766.182,399.439,770.994,398.893Z",
    transform: "translate(-687.938 -339.051)",
    opacity: 0.099
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7505",
    "data-name": "Path 7505",
    d: "M-1.194-4.58l6.9-.683S4.595,5.112,2.926,5.232-1.194-4.58-1.194-4.58Z",
    transform: "translate(61.102 38.392)",
    fill: "#9e616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7497",
    "data-name": "Path 7497",
    d: "M718.251,280.353a47.765,47.765,0,0,0-1.608-8.44,13.685,13.685,0,0,0-4.234-6.744c-3.148-2.416-7.224-1.95-10.754-.56a16.143,16.143,0,0,0-7.319,5.335,12.789,12.789,0,0,0-2.29,9.808l11.3-3.176-.412.347a10.752,10.752,0,0,1,4.853,7.527,12.815,12.815,0,0,1-1.987,9.312l7.7-3.252c1.585-.669,3.281-1.44,4.221-3.156C718.808,285.364,718.555,282.727,718.251,280.353Z",
    transform: "translate(-647.313 -263.002)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7498",
    "data-name": "Path 7498",
    d: "M611.69,339.615l-7.531,11.419a1.963,1.963,0,0,1-3.457-.334,1.837,1.837,0,0,1-.118-.379,2.014,2.014,0,0,1,.293-1.5l7.531-11.419a1.959,1.959,0,0,1,2.734-.553A2,2,0,0,1,611.69,339.615Z",
    transform: "translate(-597.342 -306.536)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7499",
    "data-name": "Path 7499",
    d: "M602.476,364.45l-1.525,2.3-2.7,2.4a1.066,1.066,0,0,1-1.306.089,1.09,1.09,0,0,1-.421-1.252l1.181-3.491,1.487-2.254Z",
    transform: "translate(-595.051 -320.874)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7500",
    "data-name": "Path 7500",
    d: "M620.221,329.644,616.447,333a1.092,1.092,0,0,0,.115,1.718l.714.481-2.065,3.131a.446.446,0,0,0,.122.614.435.435,0,0,0,.608-.123L618,335.694l.714.481a1.069,1.069,0,0,0,1.489-.3,1.1,1.1,0,0,0,.124-.256l1.617-4.813a1.091,1.091,0,0,0-.422-1.252,1.066,1.066,0,0,0-1.306.089Z",
    transform: "translate(-605.541 -302.554)",
    fill: "#3f3d56"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTravelImage2);
export default __webpack_public_path__ + "static/media/travelImage2.320fd36c922a88d500757cac15fede51.svg";
export { ForwardRef as ReactComponent };